import { useTheme } from '@mui/system';
import { CSSProperties } from 'react';

interface NextIconProps {
  style?: CSSProperties;
}

export const NextIcon = ({ style }: NextIconProps) => {
  const theme = useTheme();
  return (
    <svg style={style} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.33346 15.8331C8.13875 15.8335 7.95005 15.7657 7.80013 15.6415C7.6297 15.5002 7.5225 15.2969 7.50218 15.0764C7.48185 14.856 7.55008 14.6365 7.69179 14.4665L11.4251 9.99979L7.82513 5.52479C7.68532 5.35263 7.6199 5.13184 7.64336 4.91131C7.66682 4.69077 7.77723 4.48869 7.95013 4.34979C8.12443 4.19643 8.35482 4.12273 8.58577 4.14646C8.81673 4.17019 9.02731 4.28919 9.16679 4.47479L13.1918 9.47479C13.4446 9.78229 13.4446 10.2256 13.1918 10.5331L9.02513 15.5331C8.85557 15.7377 8.59866 15.8491 8.33346 15.8331Z"
        fill={theme.palette.primary.main}
      />
    </svg>
  );
};
